var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upModel',{staticClass:"hp-up-popup-container",attrs:{"title":_vm.title,"show":_vm.show,"showCloseBtn":true,"autoHeight":true,"buttons":_vm.showCloseBtn
      ? [
          {
            label: _vm.label,
            onClick: function () { return _vm.$emit(_vm.customClose ? 'customClose' : 'close'); }
          }
        ]
      : []},on:{"close":_vm.close}},[_c('div',{ref:"ruleModel",staticClass:"hp-up-popup-rule-model"},[_vm._t("default"),_vm._v(" "),_vm._t("bottom")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }